import { makeStyles } from "tss-react/mui";

import { TransformationType } from "@/types/thread";

export const useStyles = makeStyles<{
  isPrivate: boolean;
  modelUsed: TransformationType;
}>()((theme, { isPrivate, modelUsed }) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(4),
  },
  header: {
    width: "100%",
    maxWidth: 605,
    display: "flex",
    alignItems: "center",
    justifyContent: isPrivate ? "flex-end" : "space-between",
    marginBottom: theme.spacing(2),
  },
  badges: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  viewModeToggleContainer: {
    marginRight: theme.spacing(2),
  },
  hdBadge: {
    display: modelUsed === TransformationType.HD ? "flex" : "none",
    background:
      "linear-gradient(45deg, rgba(255, 215, 0, 0.8),rgba(218, 165, 32, 0.8),rgba(255, 223, 0, 0.9),rgba(218, 165, 32, 0.8), rgba(255, 215, 0, 0.8))",
    fontWeight: 700,
    cursor: "auto",
  },
  hdrBadge: {
    display: modelUsed === TransformationType.Flux_Pro ? "flex" : "none",
    background:
      "linear-gradient(45deg, rgba(255, 215, 0, 0.8),rgba(218, 165, 32, 0.8),rgba(255, 223, 0, 0.9),rgba(218, 165, 32, 0.8), rgba(255, 215, 0, 0.8))",
    fontWeight: 700,
    cursor: "auto",
  },
  enhanceBadge: {
    display: modelUsed === TransformationType.Enhance ? "flex" : "none",
    background:
      "linear-gradient(45deg, rgba(0, 0, 139, 1), rgba(15, 15, 94, 0.8), rgba(42, 42, 165, 0.9), rgba(15, 15, 94, 0.8), rgba(0, 0, 139, 0.8))",
    fontWeight: 700,
    color: "#ffffff",
    cursor: "auto",
  },
  upscaleBadge: {
    display: modelUsed === TransformationType.Upscale ? "flex" : "none",
    background:
      "linear-gradient(45deg,rgba(192, 192, 192, 1),rgba(169, 169, 169, 0.8),rgba(211, 211, 211, 0.9),rgba(169, 169, 169, 0.8),rgba(192, 192, 192, 0.8))",
    fontWeight: 700,
    cursor: "auto",
  },
  tags: {
    display: "flex",
    flexWrap: "wrap",
    maxWidth: 605,
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: theme.spacing(1),
  },
  promptContainer: {
    textAlign: "left",
    maxWidth: 605,
    width: "100%",
  },
  footerControls: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    maxWidth: 605,
    width: "100%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  dateCreated: {
    width: 605,
    maxWidth: 605,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    "& > p": {
      fontSize: "0.9rem !important",
      color: theme.palette.text.secondary,
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  publicFooterControls: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(4),
  },
  feedControls: {
    width: "100%",
    maxWidth: 605,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      gap: theme.spacing(2),
    },
  },
}));
